<section class="mx-3">
  <div class="d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center">
      <div>
        <button mat-icon-button class="back_icon me-2" (click)="showCourses()">
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>
      <div>
        <h4 class="m-0" translate>Course Details</h4>
      </div>
    </div>
    <div>
      <div class="">
        <div class="bulk_button">
          <input #csvInput hidden="true" type="file" onclick="this.value=null" (change)="csvInputChange($event)" />
          <button mat-raised-button class="bulk_button_add" (click)="csvInput.click()">
            <img src="../../../assets/icons/fileupload.svg" class="me-2" alt="upload icon" />
            <span translate>Bulk Upload</span></button>
          <button mat-raised-button [matMenuTriggerFor]="menu" class="m-0 p-0 bulk_button_view action_button">
             <i class="fa-solid fa-angle-down"></i>
          </button>
        </div>
        <mat-menu #menu="matMenu" class="download_menu">
          <button mat-menu-item class="download_button">
            <span translate>Download Sample</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>

  <div class="mt-3 semester_details_card">
    <div class="card bg-white p-3">
      <div *ngIf="CourseData">
        <div class="row">
          <div class="col-sm-5">
            <p class="m-0 fs-5">{{ CourseData?.course_name }}</p>
            <small class="m-0"><span translate>Organisation Name:</span> {{CourseData.organization_name}}</small>
          </div>
          <div class="col-sm-5">
            <p class="m-0" translate>Course code<span class="px-2">:</span>{{ CourseData?.course_code }}</p>
            <p class="m-0" translate>Semesters<span class="px-2">:</span>{{ CourseData?.number_of_semisters }}</p>
          </div>
          <div class="edit_menu_show col-sm-2 d-flex justify-content-end">
              <i class="fa-solid fa-ellipsis-vertical" [matMenuTriggerFor]="menu" class="update_button" aria-hidden="false" aria-label="more option"></i>
            <mat-menu #menu="matMenu">
              <!-- <small mat-menu-item>Edit</small> -->
              <small mat-menu-item (click)="toggleCoursesState(CourseData)">
                {{CourseData.status === 'ACTIVE' ? 'Disable' : 'Enable'}}
              </small>
            </mat-menu>
          </div>
        </div>
        <div class="mt-3">
          <p class="m-0 text_color_light">
            {{ CourseData?.description }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="semester_details_card">
    <div class="bg-white card my-4 p-2">
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="Semesters">
          <div class="mt-3" *ngIf="semesterData?.length > 0; else semisternodata">
            <mat-accordion class="example-headers-align bg-card-color">
              <div *ngFor="let semester of semesterData; let i=index">
                <div class="semester_expansion_panel">
                  <mat-expansion-panel [expanded]="step === i" (opened)="setStep(i, semester)">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <span translate>Semester</span> {{semester.semister}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <hr class="m-0" />
                    <div class="m-3">
                      <div>
                        <button mat-flat-button color="primary" class="w-100 add_button" color="primary"
                          (click)='openSubjects()'>
                          <i class="fa-solid fa-plus"></i>
                          <span translate>Add Subjects</span>
                        </button>
                      </div>
                      <div *ngIf="semestesubjectsData?.length > 0; else Nodata">
                        <div class="mt-3">
                          <div class="row">
                            <div class="col-sm-4" *ngFor="let subjects of semestesubjectsData">
                              <div *ngIf="subjects.semester_id === semester.id">
                                <div class="card mt-2" [ngClass]="{'dimmed': subjects.status === 'INACTIVE'}"
                                  style="background-color: #EDEDF4;">
                                  <div class="row g-0">
                                    <div class="col-md-4">
                                      <img #img [src]="assetUrl + assetContainer + '/' + subjects?.image_path" style="height: 120px; width: 100%;"
                                        (error)="img.src = onerror" class="img-fluid rounded-start" alt="...">
                                    </div>
                                    <div class="col-md-8 position-relative">
                                      <div class="card-body py-2 px-2">
                                        <p class="card-title bold">{{subjects.subject_name}}</p>
                                        <p class="m-0"><small class="card-text"><span translate>Code</span><span class="mx-2">:</span>
                                            {{subjects.subject_code}}</small></p>
                                        <p class="m-0"><small class="card-text"><span translate>Credits</span> <span class="mx-2">:</span>
                                            {{subjects.subject_credits}}</small></p>
                                      </div>
                                      <!-- <div class="d-flex justify-content-end p-1">
                                        <div class="edit_menu_show col-sm-2 d-flex justify-content-end">
                                          <span [matMenuTriggerFor]="menu" aria-hidden="false"
                                          aria-label="more option">
                                            <i class="fa-solid fa-ellipsis-vertical"></i> </span>
                                          <mat-menu #menu="matMenu">
                                            <small mat-menu-item (click)="editsubjects(subjects)">Edit</small>
                                            <small mat-menu-item (click)="toggleSubjectState(subjects)">
                                              {{subjects.status === 'ACTIVE' ? 'Disable' : 'Enable'}}
                                            </small>
                                          </mat-menu>
                                        </div>
                                      </div> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ng-template #Nodata>
                        <div class="my-4" translate>No Subjects</div>
                      </ng-template>
                    </div>
                  </mat-expansion-panel>
                </div>
              </div>
            </mat-accordion>
          </div>
          <ng-template #semisternodata>
            <div class="my-4">
              <div class="d-flex justify-content-center">
                <button mat-flat-button color="primary" class="add_button" (click)="openAddSemisterDialog()" translate>Add Semister</button>
              </div>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab label="History" translate> No Data </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</section>